// extracted by mini-css-extract-plugin
export default {"root":"IconCategoryPlane_root__9hNwF"};